<div class="bk-dialog bk-modal__large">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		{{'Add' | translate }} {{'Weather Stations' | translate }}
	</h4>

	<ranch-weather-station-form
		[isRanchAgnostic]="true"
		[ranchCoordinates]="data.ranchCoordinates"
		[selectedStationIds]="data.selectedStationIds"
		(onCancel)="dialogRef.close()"
		(onHide)="hide()"
		(onShow)="show()"
		(onSubmit)="submit($event)">
	</ranch-weather-station-form>

	<div mat-dialog-actions align="end">
		<button mat-button
			class="bk-button bk-button--medium
			bk-button--text-only bk-dialog__button--secondary"
			(click)="close()">
			{{'Cancel' | translate }}
		</button>
		<button mat-button
			class="bk-button bk-button--medium"
			(click)="weatherStationForm.submitSelectedStations()">
			{{'Add' | translate }} {{'Selected Station(s)' | translate }}
		</button>
	</div>
</div>
